import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AboutAuth from "../../components/UI/AboutAuth";

import { useStore } from "../../hook-store/store";

// import AboutPageImage1 from "../../images/audio-tools-image-crop-h200.jpg";
// import AboutPageImage2 from "../../images/cloud-sync-crop-h200.png";

import { kuraStorageLink } from '../../App';

import { marks } from "../../utils/marks";
// import './AboutPage.css';

const TranscribeAudioAbout = (props) => {

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  const { isAuth } = store.uiStore;

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // },[]);

  return (
    <Fragment>
      <div>
        {/* <div className="aboutPageTitle">
          Kura Text Audio Tools
        </div> */}

        {/* <div className="aboutPageTopImages">
          <div>
            <img className="aboutPageTopImage"
              src={AboutPageImage1}
            />
          </div>
          <div>
            <img className="aboutPageTopImage"
              src={AboutPageImage2}
            />
          </div>
        </div> */}

        <p>
          In <strong>Audio transcriber,</strong> 
          {' '}
          {t('aboutPage.18', 'by using advanced AI-technologies, user can generate text transcript from audio sources such as audio file, video file, and recorded voices.')}
        </p>
        <p>
          {t('aboutPage.29', 'It creates files for subtitles from audio or video as well.')}
        </p>
        <p>
          {t('aboutPage.19', 'It is possible to choose a language for generating text from more than 90 different languages.')}
          {' '}
          {marks.fileAudioOMark}{marks.fileVideoOMark} {`-->`} {marks.fileTextOMark} 
        </p>
        {/* <p>
          If users have account in Kura Storage, generated text and audio data can be stored for later use at Kura Storage. These files can be accessed from both desktop and mobile devices.
          It is possible to create account from this page by signup.
        </p> */}
        {/* <br/> */}
      
        {/* <p>
          {t('aboutPage.23', 'Generated audio and text data can be stored')} 
          {' '}
          at{' '} 
          <a href={`${kuraStorageLink}/about`}
            target="_blank" rel="noopener noreferrer"
          >
            <strong>Kura Storage</strong>
          </a>.
          {' '}
          {t('aboutPage.24', 'These files can be accessed from both desktop and mobile devices for later usage.')}
        </p> */}

        {/* <br/> */}
        {!isAuth && (
          <AboutAuth />
        )}
      </div>
    </Fragment>
  );
};
export default TranscribeAudioAbout;
